<template>
    <div>
      <el-dialog :visible.sync="dialogVisible" @close="close">
        <el-table :data="tableData" stripe border>
          <el-table-column prop="poId" :label="$t('billingPage.POID')" align="center" />
          <el-table-column prop="orderId" :label="$t('form.oddNumbers')" align="center" />
          <el-table-column prop="returnOrderId" :label="$t('ReturnOrderText')" align="center" />
          <el-table-column prop="consignmentNo" :label="$t('CustomerFunction.common.logisticsNo')" align="center" />
          <el-table-column prop="description" :label="$t('billingPage.comments')" align="center" />
          <el-table-column prop="gmtCreate" :label="$t('billingPage.createdAt')" align="center" />
          <el-table-column prop="updatedBy" :label="$t('BjDialogListConfig.Operator')" align="center" />
        </el-table>
      </el-dialog>

      <el-dialog :visible.sync="dialogVisible2" width="400px" @close="close">
        <el-form>
          <el-form-item :label="$t('billingPage.description')">
            <BjInput v-model="form.description" type="textarea" :maxlength="MAX_LENGTH.BILLMAX" show-word-limit autosize :placeholder="$t('inputText')" clearable />
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible2 = false">{{ $t('cancelText') }}</el-button>
          <el-button type="primary" @click="onConfirm">{{ $t('okText') }}</el-button>
        </div>
      </el-dialog>

      <el-dialog :visible.sync="dialogVisible3" width="400px" @close="close">
        <el-form ref="form2" :model="form2" :rules="rules">
          <el-form-item :label="$t('billingPage.quantity')" prop="quantity">
            <BjInputMoney v-model="form2.quantity" :placeholder="$t('inputText')" clearable />
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible3 = false">{{ $t('cancelText') }}</el-button>
          <el-button type="primary" @click="onConfirm">{{ $t('okText') }}</el-button>
        </div>
      </el-dialog>
    </div>
</template>

<script>
export default {
  data() {
    return {
        dialogVisible: false,
        dialogVisible2: false,
        dialogVisible3: false,
        tableData: [],
        form: {
          transNo: null,
          description: '',
        },
        form2: {
          transNo: null,
          quantity: ''
        },
        rules: {
          quantity: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
        },
    }
  },
  methods: {
    onConfirm(){
      if(this.dialogVisible2){
        this.$emit('reject', this.form)
      }else{
        this.$refs.form2.validate((valid) => {
          if(valid){
            if(!this.form2.quantity || this.form2.quantity == '0.00')return this.msgError(this.$t('inputText') +' ' + this.$t('billingPage.quantity'));
            this.$emit('edit', this.form2)
          }
        })
      }
    },
    close(){
      this.form = { transNo: null, description: ''}
      this.form2 = { transNo: null, quantity: ''}
      this.dialogVisible = false;
      this.dialogVisible2 = false;
      this.dialogVisible3 = false;
    }
  }
}
</script>